import { Flex } from 'antd';
import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { DASHBOARD, LOGIN } from '@/constants/routes';
import { useApiFeedback } from '@/hooks/useApiFeedback';
import { useUrlState } from '@/hooks/useUrlState';
import { useAppDispatch } from '@/store/hooks';
import { confirmLoginWithGoogle } from '@/store/userSlice';

const GoogleRedirectHandler = () => {
  const { history } = useUrlState();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { showError } = useApiFeedback();
  useEffect(() => {
    const confirmLogin = async () => {
      const search = location.search;
      if (search) {
        const result = await dispatch(confirmLoginWithGoogle(search));
        if (
          confirmLoginWithGoogle.fulfilled.match(result) &&
          result.payload.user
        ) {
          history.push(DASHBOARD);
        }
        if (confirmLoginWithGoogle.rejected.match(result)) {
          const payload = result.payload as { error?: string } | undefined;
          if (payload?.error) {
            showError(payload.error, 5);
            history.push(LOGIN);
          }
        }
      }
    };
    void confirmLogin();
  }, [dispatch, location, history, showError]);

  return (
    <Flex
      component="section"
      style={{
        background: 'var(--ant-color-bg-spotlight)',
        width: '100%',
        minHeight: '100vh',
        overflow: 'hidden',
      }}
    />
  );
};

export default GoogleRedirectHandler;
